import * as postMessage from './../privates/postMessage';

export default function ga(...args) {
    postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
        command: postMessage.MessageTypes.GOOGLE_ANALYTICS,
        data: args
    });
}



// WEBPACK FOOTER //
// ./js/modules/privates/analytics.es6